import { DropDownItemType } from 'common/components/drop-downs/legacy/dropDownItemType';

export const RangeRoutes = [
  {
    isActive: false,
    key: 'day',
    label: 'Day'
  },
  {
    isActive: false,
    key: 'week',
    label: 'Week'
  },
  {
    isActive: false,
    key: 'month',
    label: 'Month'
  },
  {
    isActive: false,
    key: 'year',
    label: 'Year'
  }
] as DropDownItemType[];

export const RangeRouteMonth = RangeRoutes.find(
  (range) => range.key === 'month'
) as DropDownItemType;
export const RangeRouteWeek = RangeRoutes.find(
  (range) => range.key === 'week'
) as DropDownItemType;

export enum DateRangeTypes {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}
